import { businessQuotesService } from '@/services/quotes/business';
import { clearClonedQuoteDraftMark } from '@/shared/utils/clone-quote-status.util';
import { useMutation, useQueryClient } from '@tanstack/react-query';

type Variables = {
  policyId: string;
};

/**
 * Envia o cálculo final da análise. POST /portal/v1/business/quotes/:policyId/submit-analysis-calculation
 * Acionado pelo botão "Enviar Cálculo" na tela de análise.
 */
export function useSubmitAnalysisCalculation() {
  const queryClient = useQueryClient();

  return useMutation<unknown, Error, Variables>({
    mutationKey: ['quotes', 'submit-analysis-calculation'],
    mutationFn: async ({ policyId }) => {
      const response = await businessQuotesService.submitAnalysisCalculation(
        policyId
      );

      if (!response.success) {
        throw new Error(response.error || 'Erro ao enviar cálculo da análise');
      }

      return response.data;
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['proposal-details', variables.policyId],
      });
      queryClient.invalidateQueries({ queryKey: ['quotes'] });
      queryClient.invalidateQueries({ queryKey: ['quotes-status-count'] });
      clearClonedQuoteDraftMark(variables.policyId);
    },
  });
}
